import PropTypes from "prop-types";

export const propTypes = {
  cauHinhCaNhan: PropTypes.object,
};

export const defaultProps = {
  cauHinhCaNhan: {},
};
